import React from "react";
import {
  Button,
  Checkbox,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import {
  ControlledCustomSelect,
  CustomFormLabel,
} from "../../../../../../../components/formsComponents";
import { LabelCard } from "../../../../../../../components/LabelCard/LabelCard";
import { StandardTableActions } from "../../../../../../../components/StandardTableActions/StandardTableActions";
import produce from "immer";
import { IAutomobilePolicyChangeProps } from "./AutomobilePolicyChange.types";
import { AutomobileVehicleInfoRightPanel } from "../../AutomobileVehicle/AutomobileVehicleInformation/AutomobileVehicleInfoRightPanel";
import { IAutomobileVehicleInformation } from "../../../../../../../redux/automobileVehicle/automobileVehicle.types";
import { useAutomobilePolicyVehcileInfo } from "../../hooks/useAutomobileVehicleInfo";
import { ConfirmDialog } from "../../../../../../../components/Dialogs/ConfirmDialog";
import { AddOutlined } from "@mui/icons-material";
import { useDispatchWrapper } from "../../../../../../../hooks";
import { clearAutomobileVehicleState } from "../../../../../../../redux/automobileVehicle/automobileVehicleActions";

export const VehcileChangeInformation: React.FC<
  IAutomobilePolicyChangeProps
> = ({
  values,
  setValues,
  errors,
  handleChange,
  setFieldValue,
  customerId,
  customerPolicyId,
  isStatusCompleted,
  autoSaveData = () => {},
}) => {
  const [open, setOpen] = React.useState<{
    type: "create" | "edit" | "view";
    index?: number;
    data?: IAutomobileVehicleInformation;
  } | null>(null);
  const theme = useTheme();
  const { vehcileDropdown,refreshVehicleList } = useAutomobilePolicyVehcileInfo(customerPolicyId);
  const dispatch = useDispatchWrapper();

  const handleCheckBoxChange = (value: string) => {
    setFieldValue("vehicle_change.type", value);
  };

  const handleSaveSuccess = (data: IAutomobileVehicleInformation) => {
    const newValues = produce(values, (draftValues) => {
      const updatedData = {
        ...data,
        customer_policy_id: customerPolicyId ?? null,
        customer_id: customerId ? Number(customerId) : null,
      };
      console.log("updated", updatedData);
      if (open && open.type === "edit" && open.index !== undefined) {
        draftValues.vehicle_change.records[open.index] = updatedData;
      } else {
        draftValues.vehicle_change.records.push(updatedData);
      }
    });
    autoSaveData(newValues);
    setValues(newValues);
    setOpen(null);
    refreshVehicleList();
  };

  const handleCreateEdit = (index?: number) => () => {
    if (isStatusCompleted) {
      return;
    }
    setOpen({
      type: index !== undefined ? "edit" : "create",
      index: index,
      data:
        index !== undefined ? values.vehicle_change.records[index] : undefined,
    });
  };

  const handleView = (index: number) => () => {
    setOpen({
      type: "view",
      index: index,
      data: values.vehicle_change.records[index],
    });
  };

  const [deleteConfirm, setDeleteConfirm] = React.useState<number | null>(null);
  const handleDelete = (index: number) => () => {
    setDeleteConfirm(index);
  };

  const handleDeleteConfirm = () => {
    if (deleteConfirm === null) {
      return;
    }
    const newValues = produce(values, (draftValues) => {
      draftValues.vehicle_change.records.splice(deleteConfirm, 1);
    });
    setValues(newValues);
    autoSaveData(newValues);
    setDeleteConfirm(null);
  };

    React.useEffect(()=>{
       return () => {
            dispatch(clearAutomobileVehicleState());
          };
    },[])
  

  return (
    <>
      <LabelCard heading="Vehicle Change" />
      <Grid container spacing={2} mb={3}>
        <Grid item xs={12} lg={2.4}>
          <Stack direction={"row"} alignItems={"center"}>
            <Checkbox
              checked={values.vehicle_change.type === "Add"}
              onChange={(e) => {
                handleCheckBoxChange(e.target.checked ? "Add" : "");
              }}
            />
            <Typography>Add</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} lg={2.4}>
          <Stack direction={"row"} alignItems={"center"}>
            <Checkbox
              checked={values.vehicle_change.type === "Delete"}
              onChange={(e) => {
                handleCheckBoxChange(e.target.checked ? "Delete" : "");
              }}
            />
            <Typography>Delete</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} lg={2.4}>
          <Stack direction={"row"} alignItems={"center"}>
            <Checkbox
              checked={values.vehicle_change.type === "Change"}
              onChange={(e) => {
                handleCheckBoxChange(e.target.checked ? "Change" : "");
              }}
            />
            <Typography>Substitution</Typography>
          </Stack>
        </Grid>
      </Grid>

      {values.vehicle_change.type &&
        ["Add", "Change"].includes(values.vehicle_change.type) && (
          <>
            <Grid container spacing={3}>
              {values.vehicle_change.type === "Change" && (
                <Grid item xs={12} md={6}>
                  <CustomFormLabel>Vehcile</CustomFormLabel>
                  <ControlledCustomSelect
                    variant="outlined"
                    size="small"
                    type="string"
                    name="vehicle_change.delete_vehicle"
                    fullWidth
                    displayEmpty
                    value={values.vehicle_change.delete_vehicle}
                    onChange={handleChange}
                    placeholder="Select One"
                    options={vehcileDropdown}
                  ></ControlledCustomSelect>
                </Grid>
              )}
              <Grid item xs={12}>
                <Stack direction={"row"} justifyContent={"end"}>
                  <Button
                    variant="contained"
                    disabled={isStatusCompleted}
                    onClick={handleCreateEdit()}
                    startIcon={<AddOutlined />}
                  >
                    New
                  </Button>
                </Stack>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>View</TableCell>
                        <TableCell>Vehicle Number</TableCell>
                        <TableCell>Vin</TableCell>
                        <TableCell>Make</TableCell>
                        <TableCell>Model</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {values.vehicle_change.records.map((item, index) => {
                        return (
                          <TableRow key={index}>
                            <TableCell sx={{ display: "flex" }}>
                              <StandardTableActions
                                onViewClick={handleView(index)}
                                onEditClick={
                                  !isStatusCompleted
                                    ? handleCreateEdit(index)
                                    : undefined
                                }
                                // onDeleteClick={
                                //   !isStatusCompleted
                                //     ? handleDelete(index)
                                //     : undefined
                                // }
                              />
                            </TableCell>
                            <TableCell>{item.incremental_number}</TableCell>
                            <TableCell>{item.vin}</TableCell>
                            <TableCell>{item.make}</TableCell>
                            <TableCell>{item.model}</TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </>
        )}

      {values.vehicle_change.type &&
        ["Delete"].includes(values.vehicle_change.type) && (
          <Grid container>
            <Grid item xs={12} md={6}>
              <CustomFormLabel>Vehcile</CustomFormLabel>
              <ControlledCustomSelect
                variant="outlined"
                size="small"
                type="string"
                name="vehicle_change.delete_vehicle"
                fullWidth
                displayEmpty
                value={values.vehicle_change.delete_vehicle}
                onChange={handleChange}
                placeholder="Select One"
                options={vehcileDropdown}
              ></ControlledCustomSelect>
            </Grid>
          </Grid>
        )}

      {open  && (
        <AutomobileVehicleInfoRightPanel
          open={true}
          vehicleNumber={open.data ? open.data.incremental_number as any: undefined}
          customerId={customerId}
          customerPolicyId={customerPolicyId}
          onSaveSuccess={handleSaveSuccess}
          readonly={open.type === "view"}
          created_from="Policy_Change"
          onClose={() => setOpen(null)}
          initialData={open.data}
        />
      )}

      {deleteConfirm !== null && (
        <ConfirmDialog
          open
          content="Are you sure you want to delete this record?"
          onClose={() => setDeleteConfirm(null)}
          onConfrim={handleDeleteConfirm}
        />
      )}
    </>
  );
};
